import { TRPCClientError } from '@trpc/client';

/** 이 상태부터는 서버·게이트웨이 쪽 장애다 — 승인 요청이 서버에 닿아 처리됐을 수 있다. */
const SERVER_ERROR_STATUS_MIN = 500;

/**
 * 링크가 TRPCClientError.meta.response 에 넣는 fetch Response 의 상태 코드.
 * 응답을 받기 전에 끝났거나(네트워크 실패·응답 본문 파싱 실패) 상태를 알 수 없으면 undefined.
 */
const responseStatusOf = (meta: Record<string, unknown> | undefined): number | undefined => {
  const response = meta?.response;

  return typeof response === 'object' &&
    response !== null &&
    'status' in response &&
    typeof response.status === 'number'
    ? response.status
    : undefined;
};

/**
 * 결제 승인 요청이 서버 응답 없이 끝났는가 — 서버는 승인했을 수 있으므로 실패로 확정하지 않고 결제 상태를
 * 다시 확인하게 한다.
 *
 * - 서버가 답한 tRPC 오류(도메인 거절·INTERNAL)는 오류 본문(data)이 있어 유실이 아니다.
 * - data 가 없고 응답 자체가 없으면(네트워크 실패·게이트웨이 HTML 파싱 실패) 유실이다.
 * - data 가 없고 응답 상태가 5xx 면 유실이다.
 * - data 가 없고 응답 상태가 4xx 면(속도 제한 429 의 Nest 봉투 등) 서버가 승인을 부르지 않았으므로 유실이 아니다.
 */
export const isConfirmReplyLost = (error: unknown): boolean => {
  if (!(error instanceof TRPCClientError) || (error.data !== undefined && error.data !== null)) {
    return false;
  }

  const status = responseStatusOf(error.meta);

  return status === undefined || status >= SERVER_ERROR_STATUS_MIN;
};
